import { useEffect, useState } from 'react';
import Table from '../../components/Table';
import { observer } from 'mobx-react-lite';
import Button from '../../components/Button';
import { useHistory } from 'react-router-dom';
import Paths from '../../constants/paths';
import { FaPlus, FaSearch } from 'react-icons/fa';
import translations from '../../translations/de';
import ItemImage from '../../components/ItemImage';
import Select from '../../components/Select';
import TabSwitcher from '../../components/TabSwitcher';
import PlayersSearch from './PlayersSearch';

const Teams = ({ store }) => {
    const history = useHistory();
    const [league, setLeague] = useState({ label: 'National', value: 'national' });

    useEffect(() => {
        const params = { league_enum: 'NL' };
        if (league.value === 'other') {
            params.other = true;
        }

        store.getTeams(params);
    }, [store, league]);

    const handleTeam = (id) => {
        store.selectTeam(id);
        history.push(`/teams/${id}`);
    };

    return (
        <TabSwitcher initialTabName={translations.teams} switcherKey="teams-page">
            <TabSwitcher.Tabs>
                <TabSwitcher.TabPill tabName={translations.teams} />
                <TabSwitcher.TabPill tabName={translations.players} />
            </TabSwitcher.Tabs>
            <TabSwitcher.TabPanel activeWhenTabName={translations.teams}>
                <div style={{ marginLeft: '2.5%', display: 'flex', alignItems: 'center' }}>
                    <Button
                        label={translations.team}
                        onClick={() => {
                            store.selectTeam(undefined);
                            history.push(Paths.NEW_TEAM);
                        }}
                        style={{ marginBottom: '15px', marginRight: '10px' }}
                    >
                        <FaPlus style={{ marginRight: '5px' }} />
                    </Button>
                    <div className="tab-controls">
                        <Select
                            label="League"
                            defaultValue={league}
                            options={[
                                { label: 'National', value: 'national' },
                                { label: 'Other', value: 'other' },
                            ]}
                            onChange={setLeague}
                        />
                    </div>
                </div>

                <Table
                    isLoading={store.isLoading}
                    tableName={translations.teams}
                    columns={[
                        {
                            Header: 'ID',
                            accessor: 'id',
                            Cell: ({ value, row }) => <div>{value}</div>,
                        },
                        {
                            Header: translations.logo,
                            accessor: 'logo_url',
                            Cell: ({ value, row }) => (
                                <div>
                                    <ItemImage imgSrc={value} alt="team" listView={true} />
                                </div>
                            ),
                        },
                        {
                            Header: translations.title,
                            accessor: 'title',
                            Cell: ({ value, row }) => <div>{value}</div>,
                        },
                        {
                            Header: '',
                            accessor: 'action',
                            Cell: ({ row }) => (
                                <div>
                                    <Button
                                        onClick={() => {
                                            handleTeam(row.cells[0].value);
                                        }}
                                        title={translations.show}
                                    >
                                        <FaSearch />
                                    </Button>
                                </div>
                            ),
                        },
                    ]}
                    data={store.teams.map(({ id, logo_url, title }) => {
                        return {
                            id,
                            logo_url,
                            title,
                        };
                    })}
                />
            </TabSwitcher.TabPanel>
            <TabSwitcher.TabPanel activeWhenTabName={translations.players}>
                <PlayersSearch store={store} />
            </TabSwitcher.TabPanel>
        </TabSwitcher>
    );
};

export default observer(Teams);
